import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styles from './lariferreiraestetica.module.scss';
import BackgroundLinks from './src/background-links.png';
import LinkWhatsapp from './src/1.png';
import LinkInstagram from './src/2.png';
import LinkLocalizacao from './src/3.png';
import LinkProcedimentos from './src/4.png';

const WHATSAPP_NUMBER = '5517996550071';
const WHATSAPP_MSG = 'Olá! Vim pelo cartão digital da Larissa Ferreira e gostaria de atendimento ou tirar dúvidas...';
const INSTAGRAM_URL = 'https://www.instagram.com/lariferreira.estetica?igsh=cm4zZTVpaW9nY3hj';
const MAPS_URL = '#';

const MARQUEE_PHRASE = 'LARISSA FERREIRA • ';
const MARQUEE_TEXT = MARQUEE_PHRASE.repeat(24);
const MARQUEE_COPIES = 4;

const whatsappLink = WHATSAPP_NUMBER
    ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`
    : '#';

const Lariferreiraestetica: React.FC = () => {
    const trackRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        const handleVisibility = () => {
            track.style.animationPlayState = document.hidden ? 'paused' : 'running';
        };

        document.addEventListener('visibilitychange', handleVisibility);
        return () => document.removeEventListener('visibilitychange', handleVisibility);
    }, []);

    return (
        <div className={styles.lariferreiraestetica}>
            <div className={styles.main}>
                <img
                    className={styles.cardImage}
                    src={BackgroundLinks}
                    alt="Larissa Ferreira — cartão digital"
                    decoding="async"
                />

                <div className={styles.marqueeContainer} aria-hidden>
                    <section className={styles.marqueeSection}>
                        <ul className={styles.marqueeTrack} ref={trackRef}>
                            {Array.from({ length: MARQUEE_COPIES }, (_, index) => (
                                <li
                                    key={index}
                                    className={styles.marqueeSlide}
                                    aria-hidden={index > 0}
                                >
                                    <div className={styles.marqueeItem}>
                                        <p className={styles.marqueeText}>{MARQUEE_TEXT}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </section>
                </div>
                <div className={styles.content}>

                    <a href={INSTAGRAM_URL} className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkInstagram}
                            alt="Instagram — acompanhe minha página"
                            decoding="async"
                        />
                    </a>
                    <a href={whatsappLink} className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkWhatsapp}
                            alt="WhatsApp — atendimentos e dúvidas"
                            decoding="async"
                        />
                    </a>
                    <Link to="/lariferreiraestetica/procedimentos" className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkProcedimentos}
                            alt="Procedimentos — conheça meus serviços"
                            decoding="async"
                        />
                    </Link>
                </div>

            </div>
        </div>
    );
};

export default Lariferreiraestetica;
